import config from 'config';
import tmpl from './manage.phtml';
import View from 'lib/View';

export default View.extend({
	template: tmpl,

	events: {
		'click [data-toggle=collapse]': 'scrollToEventTarget',
		'keyup textarea': 'removeInvalidFeedback',
		'change :input': 'onChange',
		'submit form': 'onSubmit',
	},

	onChange: function( evt )
	{
		this.removeInvalidFeedback( evt );
		this.updateForm();
	},

	onSubmit: function( evt )
	{
		evt.preventDefault();

		var data = this.$("form").serializeJSON();
		this.model.set( data );
		if( this.model.isValid() )
		{
			this.model.set('todo','draft');
			app.persistModel( this.model ).then( function()
			{
				app.redirect( this.model.toUrl('visit/view') );
			}.bind( this ) );
			return;
		}

		this.render();
	},

	updateForm: function()
	{
		var data = this.$("form").serializeJSON();

		// Si je connais la mare
		this.toggleInput( "info_permanent", data.info_knowing == 'Oui' && data.info_water == 'Oui' );
		this.toggleInput( "info_actions", data.info_knowing == 'Oui' );

		// Type de route
		this.toggleInput( "info_road_type", data.info_road && data.info_road != 'Supérieur à 250m' );


		// Je suis propriétaire
		this.toggleInput( "info_owner_hidden", data.info_property == "Privé" );
		this.toggleInput( "info_owner_action", data.info_property == "Privé" );


		// L'eau => profondeur
		this.toggleInput( "info_depth", data.info_water == 'Oui' );
		this.toggleInput( "info_clarity", data.info_water == 'Oui' );
		this.toggleInput( "info_smell", data.info_water == 'Oui' );


		// Détails environnements
		this.toggleInput( "info_environment_open", data.info_environment == 'Zone plutôt agricole' );
		this.toggleInput( "info_environment_closed", data.info_environment == 'Zone plutôt forestière' );
		this.toggleInput( "info_environment_urban", data.info_environment == 'Zone urbanisée' );
		this.toggleInput( "info_environment_other", data.info_environment == 'Autres' || data.info_environment_open == 'Autres' );

		// Surface de la mare
		this.toggleInput( "info_area_size", data.info_area == 'Oui' );
		this.toggleInput( "info_area_list", data.info_area == 'Non' );


		// Espece exotiques
		this.toggleInput( "info_eee_details", data.info_eee_expert == 'Oui' );
		this.toggleInput( "info_eee_other", data.info_eee_expert == 'Oui' && _.contains(data.info_eee_details,'Autres') );

		// Autre faune
		this.toggleInput( "info_animals_other", _.contains(data.info_animals,'Autres') );
		this.toggleInput( "info_insects_other", _.contains(data.info_animals,'Autres insectes') );

		// Autre travaux sur berge
		this.toggleInput( "info_actions_other", _.contains(data.info_actions,'Autres') );

		// Autre menaces
		this.toggleInput( "info_threat_other", data.info_threat == 'Oui' );

		// Montrer les erreurs du formulaire
		this.$(".toggle-accordion-content").each(function()
		{
			$(this).toggleClass( 'text-danger', $( $(this).data('target') ).find('.is-invalid').length > 0 );
		});
	},

	toggleInput: function( id, show )
	{
		this.$('#field-'+id).toggleClass( 'd-none', !show );

		// Si on masque, alors on efface
		if( !show )
		{
			this.$('#field-'+id).find(':input').each(function()
			{
				if( $(this).is('select[multiple]') )
				{
					$(this).val([]);
				}
				else if( $(this).is('select') )
				{
					$(this).prop( 'selectedIndex', 0 ) ;
				}
				else if( $(this).is(':checkbox') )
				{
					$(this).prop('checked',false);
				}
				else if( $(this).is(':radio') )
				{
					$(this).prop('checked',false);
				}
//				else if( $(this).prop('checked') )
//				{
//					$(this).prop('checked',false);
//				}
				else
				{
					$(this).val('');
				};
			});
		}
// 		else
// 		{
// 			this.$(id).
// 		}
	},

	render: function()
	{
		this.doRender({
			visit: this.model,
			pond: this.model.getPond(),
			form: app.getStore('data').get('form'),
		});

		this.updateForm();
	}
});
